import { render } from "./Colaborador.vue?vue&type=template&id=4b439055"
import script from "./Colaborador.vue?vue&type=script&lang=js"
export * from "./Colaborador.vue?vue&type=script&lang=js"

import "./Colaborador.vue?vue&type=style&index=0&id=4b439055&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__